import type { IsoDate, YearMonth } from '../data/types';

const euro = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const compactEuro = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  notation: 'compact',
  maximumFractionDigits: 1,
});

// Le date del contratto sono giorni di calendario costruiti in UTC: vanno formattate in UTC,
// altrimenti in un fuso negativo il 1° gennaio diventerebbe il 31 dicembre precedente.
const monthFormatter = new Intl.DateTimeFormat('it-IT', {
  month: 'short',
  year: '2-digit',
  timeZone: 'UTC',
});
const dateFormatter = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
});
const axisDayFormatter = new Intl.DateTimeFormat('it-IT', {
  day: '2-digit',
  month: 'short',
  year: '2-digit',
  timeZone: 'UTC',
});

export function formatCents(value: number): string {
  return euro.format(value / 100);
}

export function formatCompactCents(value: number): string {
  return compactEuro.format(value / 100);
}

export function formatPercent(value: number | null): string {
  return value === null
    ? 'Non significativo'
    : new Intl.NumberFormat('it-IT', {
        style: 'percent',
        signDisplay: 'exceptZero',
        maximumFractionDigits: 1,
      }).format(value);
}

export function formatMonth(value: YearMonth | string): string {
  const [year = 0, month = 1] = value.split('-').map(Number);
  return monthFormatter.format(new Date(Date.UTC(year, month - 1, 1)));
}

export function formatDate(value: IsoDate | string): string {
  const [year = 0, month = 1, day = 1] = value.split('-').map(Number);
  return dateFormatter.format(new Date(Date.UTC(year, month - 1, day)));
}

/** Etichetta compatta per assi: `2025-03` → «mar 25», `2025-03-04` → «04 mar 25». */
export function formatAxisBucket(value: string): string {
  if (/^\d{4}-\d{2}$/.test(value)) return formatMonth(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year = 0, month = 1, day = 1] = value.split('-').map(Number);
    return axisDayFormatter.format(new Date(Date.UTC(year, month - 1, day)));
  }
  return value;
}

export function signedClass(value: number): 'positive' | 'negative' | 'neutral' {
  return value > 0 ? 'positive' : value < 0 ? 'negative' : 'neutral';
}
